import React from 'react';
import { initialsFor } from './utils';

const AccountHeader = ({ name, subtitle = 'Corporate Account' }) => (
    <div className="onward-design">
        <div className="flex items-center gap-3.5">
            <div
                className="flex size-[60px] shrink-0 items-center justify-center rounded-full bg-[#024791]"
                aria-hidden="true"
            >
                <span className="text-[28px] font-extrabold text-white">{initialsFor(name)}</span>
            </div>
            <div className="flex min-w-0 flex-col justify-center">
                <span className="truncate text-[24px] font-extrabold leading-tight text-[#0c0b1d]">{name}</span>
                <span className="text-[14px] text-black">{subtitle}</span>
            </div>
        </div>
    </div>
);

export default AccountHeader;
